module.exports = __webpack_public_path__ + "acd3ca66fcdcaa709b8a7f50188d5461.svg";